import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import tradetronWelcome from "./../../../Images/tradetronWelcome.png";
import Quantman from './../../../Images/tools/Quantman/Quantman.png'
import "./QuantmanWelcome.css";
function QuantmanWelcome(props) {
  console.log(props);
  return (
    <>
      <section className="Quantmanwelcome_section">
        <Container>
          <Row className="align-items-center">
            <Col md={7}>
              <div>
                <h3>{props.data.title}</h3>
                <p>Quantman is an online strategy testing and trading platform. Backtest using QuantMan with over <strong>5+ years</strong> of futures and options data. Find patterns and strategies.</p>
                <p>Without complicated setup, deploy backtested strategies using one <strong>click</strong></p>
              </div>
            </Col>
            <Col md={5}>
              <div className="QuantmanWelcome_img pl-3">
                <img
                  className="img-fluid"
                  src={Quantman}
                  alt="Quantman"
                />
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
}
export default QuantmanWelcome;
